import { rem } from 'polished';
import styled from 'styled-components';

export const StyledListingCadastralDateBody = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  gap: ${rem('34px')};
  border-radius: ${rem('10px')};
  padding: ${rem('24px')};
  margin-top: ${rem('24px')};
`;
